<script lang="ts">
  import PaymentDetailView from '../../../components/admin/payments/PaymentDetailView.svelte';
  export let params: { uuid: string };
</script>

<PaymentDetailView paymentUuid={params.uuid} />

